
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {manufactoryApi, mechanismApi, qiChaChaApi} from "@/api/organization";
    import {draftApi} from "@/api/rules";
    import {IPage} from "@/js/page";

    @Component
    export default class AddManufactory extends Vue {
        title = "添加、编辑制造单位";
        listData = [];
        addManufactoryDialog = true;
        creditCode = "";
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        load = false;
        loadList = false;
        listNo = false;  //搜不到数据
        list = [];
        form = {
            code: "",
            name: "",
            residence: "",
            userName: "",
            postalAddress: "",
            userMobile: "",
            originalName: [], //附加
        } as any
        rules = {
            code: [{required: true, message: '请输入统一社会信用代码', trigger: 'blur'}],
            name: [{required: true, message: '请输入单位名称', trigger: 'blur'}],
            residence: [{required: true, message: '请输入单位注册地址', trigger: 'blur'}],
            userName: [{required: true, message: '请输入法人代表/负责人', trigger: 'blur'}],
            postalAddress: [{required: true, message: '请输入单位通讯地址', trigger: 'blur'}],
            userMobile: [{required: true, message: '请输入联系手机号', trigger: 'blur'}],
        }
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        manually = false;  //手动添加

        /**
         * 编辑的id
         * */
        @Prop() private id!: any;
        @Prop() private editData!: any;
        @Prop() private type!: any;  //来源 0:注册单位 1:制作的单位 2:起草单位 3:发证机关 4:发布机关"
        created() {
            if (this.id) {
                for (const f in this.form) {
                    if (this.editData[f]) this.form[f] = this.editData[f];
                }
                this.load = true;
            }
        }

        queryBtn() {
            if (this.creditCode == "") {
                this.$message.error("请输入统一社会信用代码/单位全称");
                return;
            }
            qiChaChaApi.listByName({name: this.creditCode, ...this.listParam, source: this.type}).then(r => {
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    this.list = rData.records;
                    this.loadList = true;
                    this.load = false;
                }
            })
        }

        queryBtn2() {
            if (this.creditCode == "") {
                this.$message.error("请输入单位全称");
                return;
            }

            qiChaChaApi.selectByCode({name: encodeURI(this.creditCode), source: this.type}).then(r => {
                if (r.data.result == 0) {
                    const rData = r.data.data;

                    this.form.code = rData.creditCode;
                    this.form.name = rData.name;
                    this.form.residence = rData.address;
                    this.form.userName = rData.operName;
                    this.form.originalName = rData.originalName;
                    this.form.postalAddress = "";
                    this.form.userMobile = "";

                    this.listNo = false;
                    this.load = true;
                    this.loadList = false;
                    this.manually = false;
                } else if (r.data.result == 1) {
                    this.listNo = true;
                    this.load = false;
                    this.loadList = false;
                    this.manually = false;
                }
            })
        }

        addManually() {
            this.form = {
                code: "",
                name: "",
                residence: "",
                userName: "",
                postalAddress: "",
                userMobile: "",
                originalName: [],
            }
            this.load = true;
            this.listNo = false;
            this.loadList = false;
            this.manually = true;
        }

        saveBtn() {
            let form = this.$refs.manufactoryForm as HTMLFormElement;
            form.validate((valid: any) => {
                if (valid) {
                    let params = this.form;
                    if (this.id) {
                        params = Object.assign(params, {id: this.id});
                    }
                    params.source = this.type;
                    // let api;
                    // if(this.type=="draft"){
                    //     params.id = 0;
                    //     api = draftApi.update(params)
                    // }else{
                    //     api = manufactoryApi.update(params)
                    // }
                    mechanismApi.add2(params).then(r => {
                        if (r.data.result === 0) {
                            this.$message.success("保存成功");
                            this.$emit("saveSuccess", r.data.data)
                        }
                    })
                }
            })
        }

        clostDialog() {
            this.$emit("clostDialog")
        }
    }
